import * as React from "react";
import { Router as ReactRouter, Route, IndexRoute, IndexRedirect, browserHistory } from "react-router";

import { ContextStore, NavigationActions } from "../Flux/Variables";
import { RootRoute, UrlHelper, RouteFragment, ParametrizedRouteFragment } from "../Imports";

export const routerHistory = browserHistory;

export interface IRouteConfig extends React.Props<Router> {
    rootRoute: RootRoute;
}

export class Router extends React.Component<IRouteConfig, any> {
    public render(): JSX.Element {
        const routes = this.buildRoute(this.props.rootRoute, () => UrlHelper.getRootRouteUrlWithoutSlash());
        /* tslint:disable:no-console */
        return (
            <ReactRouter
                history={routerHistory}
                onError={(error) => console.warn("Routing.Router: error in routing", error)}
            >
                {routes}
                {/* <Route path="*" onEnter={() => window.location.replace("/PageNotFound.aspx")} /> */}
            </ReactRouter>
        );
    }

    private buildRoute(config: RouteFragment, pathFunction: (config: RouteFragment) => string): JSX.Element {
        if (!config) {
            return null;
        }

        const childRoutes: JSX.Element[] = [];
        let indexRoute: JSX.Element = null;

        if (config.children && config.children.length && config.children.length >= 1) {
            for (let i = 0; i < config.children.length; i++) {
                childRoutes.push(
                    this.buildRoute(config.children[i], (routeConfig: RouteFragment) => routeConfig.getRoute())
                );
            }
        }

        if (config.indexComponent) {
            indexRoute = <IndexRoute component={config.indexComponent} />;
        }

        if (config.indexRedirectUrl) {
            indexRoute = <IndexRedirect to={config.indexRedirectUrl} />;
        }

        let onEnter: any = () => {
            NavigationActions.enter(config);
        };

        const onLeave: any = () => {
            NavigationActions.enter(config.parent);
        };

        if (config instanceof ParametrizedRouteFragment) {
            if (config.getOnEnterCallbacks()) {
                onEnter = (newState) => {
                    config.getOnEnterCallbacks().forEach((x) => x(newState.params));
                    NavigationActions.enter(config);
                };
            }
        }

        return (
            <Route
                path={pathFunction(config)}
                key={pathFunction(config)}
                component={config.component}
                onEnter={onEnter}
                onLeave={onLeave}
            >
                {indexRoute}
                {childRoutes}
            </Route>
        );
    }
}
